import { createSlice } from "@reduxjs/toolkit";
import { getProduct } from "../../reduxApi/admin/ProductReduxApi";

const ProductSlice = createSlice({
  name: "products",
  initialState: {
    status: "idle",
    products: [],
    error: null,
  },
  reducers: {
    addProductAction: (state, action) => {
      // console.log("Adding proct:", action.payload);
      const temp = action.payload.formData;
      temp.ROWID = action.payload.ROWID;
      state.collactions.unshift({ products: temp });
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getProduct.fulfilled, (state, action) => {
      // console.log("API Response:", action.payload);
      state.status = "fulfilled";
      // state.products = action.payload.products;
      state.products = Array.isArray(action.payload.products)
        ? action.payload.products
        : [];
      // console.log("state.products", state.products);
    });
  },
});

export default ProductSlice.reducer;
